import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/requisitionItemsReport'
import Component from 'components/Reports/RequisitionItemsReport'

export default createListViewContainer({ actions, selectors: selectors.requisitionItemsReport })(Component)
